var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"commonClientinfoheadpath"},[_c('h2',[_vm._v("\n    "+_vm._s(_vm.token.user)+"\n    "),_c('hr')]),_vm._v(" "),_c('img',{staticClass:"img-thumbnail img rounded",attrs:{"src":_vm.token.headpath,"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-256dad64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/clientinfo/headpath.vue
// module id = null
// module chunks = 